import React from 'react';

export function Airport({code, name} : {code: string, name: string}) {
  return (
    <div>
      <div className="tw-text-4xl tw-font-semibold">{ code }</div>
      <div className="tw-text-base" style={{padding: "0 2px"}}>{ name }</div>
    </div>
  )
}